<div class="blue-background">
  <div style="margin-left: auto; margin-right: auto">
    <div class="ylapalkki">
      <button class="sulje" mat-button (click)="peruuta()" type="button">
        <i style="font-size: 60px; width: 60px; height: 60px; line-height: 60px; display: inline-block" class="icon ion-md-arrow-back"></i>
      </button>

      <h2 style="margin: 0; width: calc(100% - 18vw); text-align: center">
        {{ otsikko }}
      </h2>
    </div>
  </div>
</div>

@if (tositteetJaTiedotObservable | async; as tositteetJaTiedot) {
  <div>
    <div class="kuitti-container">
      @if (initialLoadDoneObservable | async) {
        <ul style="margin-bottom: 80px">
          @for (bakkarissa of tositteetJaTiedotBackendissaObservable | async; track bakkarissa) {
            @for (t of bakkarissa.tiedostotSubject | async; track t) {
              @if (t.tila === 'backend') {
                <li>
                  {{ 'kuitit.muokkaa.validation.purkuvirhe-lahetetty-backend' | translate: { file_name: t.uploadData.filename } | async }}
                </li>
              }
              @if (t.tila === 'purkuvirhe') {
                <li>
                  {{ 'kuitit.muokkaa.validation.purkuvirhe-myos-backend' | translate: { file_name: t.uploadData.filename } | async }}
                  @if (tositteetJaTiedot?.length > 0) {
                    {{ 'kuitit.muokkaa.validation.purkuvirhe-myos-backend-voit-tallentaa-muut' | translate | async }}
                  }
                </li>
              }
              @if (t.tila === 'latausvirhe') {
                <li>
                  {{ 'kuitit.muokkaa.validation.latausvirhe' | translate: { file_name: t.uploadData.filename } | async }}
                </li>
              }
              @if (t.tila !== 'latausvirhe' && t.tila !== 'purkuvirhe' && t.tila !== 'backend') {
                <li>
                  {{ 'kuitit.muokkaa.validation.tuntematon-virhe' | translate: { file_name: t.uploadData.filename } | async }}
                </li>
              }
            }
          }
        </ul>
      }
      @if (tositteetJaTiedot.length > 1) {
        <div style="margin-bottom: 10px">
          <mat-checkbox (change)="yhdistaKuitit($event)" style="font-size: 14px">{{ 'kuitit.muokkaa.yhdista' | translate | async }}</mat-checkbox>
        </div>
      }
      @if (tositteetJaTiedot.length < 1 && (initialLoadDoneObservable | async)) {
        <div class="error-text" style="margin: 2em">
          {{ 'kuitit.muokkaa.validation.ei-yhtaan-purettua' | translate | async }}
        </div>
      }
      <div>
        @for (tositeJaTiedot of tositteetJaTiedot; track tositeJaTiedot; let i = $index) {
          <div class="tosite-container">
            <div class="tosite-tiedot">
              <form novalidate autocomplete="kirjanpitoaineistoarkki" style="width: 100%">
                @if (tositteetJaTiedot.length > 1) {
                  <h1 style="font-size: 28px; line-height: 34px; text-align: left" class="light-blue-text">{{ 'kuitit.muokkaa.tosite' | translate | async }} {{ i + 1 }}</h1>
                }
                @if (showMaksutapa) {
                  <div style="padding-bottom: 5px">
                    <div class="mat-form-field" style="font-size: 10.5px">{{ 'kuitit.muokkaa.maksettu' | translate | async }} *</div>
                    <app-kuitit-maksutapa [formField]="tositeJaTiedot.lomake.maksutapa" [filterNonActive]="true" [error]="virheet(tositeJaTiedot.lomake.maksutapa)?.length"></app-kuitit-maksutapa>
                    @if (tositeJaTiedot.lomake.maksutapa; as n) {
                      <mat-error>
                        @if (n().dirty() || n().touched()) {
                          @if (virheet(n)?.required) {
                            {{ 'kuitit.muokkaa.validation.maksutapa.required' | translate | async }}
                          }
                        }
                      </mat-error>
                    }
                  </div>
                }
                @if (showPvm) {
                  @if (!showPvmAsMonth) {
                    <mat-form-field>
                      <mat-label>{{ pvmText }}</mat-label>
                      <input numberDatePicker matInput [formField]="tositeJaTiedot.lomake.pvm" #pvmVar="matInput" [matDatepicker]="dayPicker" [min]="minDate" [max]="maxDate" autocomplete="kirjnpitomekiarki" data-lpignore="true" />
                      @if ((pvmVar?.ngControl?.dirty || pvmVar?.ngControl?.touched) && pvmVar.ngControl?.errors?.required) {
                        <mat-error>{{ 'kuitit.muokkaa.validation.pvm.required' | translate | async }}</mat-error>
                      }
                      @if ((pvmVar?.ngControl?.dirty || pvmVar?.ngControl?.touched) && pvmVar.ngControl?.errors?.matDatepickerParse) {
                        <mat-error>{{ 'kuitit.muokkaa.validation.pvm.matDatepickerParse' | translate | async }}</mat-error>
                      }
                      @if ((pvmVar?.ngControl?.dirty || pvmVar?.ngControl?.touched) && pvmVar.ngControl?.errors?.matDatepickerMax) {
                        <mat-error>{{ 'kuitit.muokkaa.validation.pvm.matDatepickerMax' | translate | async }}</mat-error>
                      }
                      @if ((pvmVar?.ngControl?.dirty || pvmVar?.ngControl?.touched) && pvmVar.ngControl?.errors?.matDatepickerMin) {
                        <mat-error>{{ 'kuitit.muokkaa.validation.pvm.matDatepickerMin' | translate | async }}</mat-error>
                      }
                      <mat-datepicker-toggle matSuffix [for]="dayPicker"></mat-datepicker-toggle>
                      <mat-datepicker #dayPicker></mat-datepicker>
                    </mat-form-field>
                  } @else {
                    <mat-form-field>
                      <mat-label>{{ pvmText }}</mat-label>
                      <input numberDatePicker monthPicker matInput [formField]="tositeJaTiedot.lomake.pvm" #pvmVar="matInput" [matDatepicker]="monthPicker" [min]="minDate" [max]="maxDate" autocomplete="kirjnpitomekiarki" data-lpignore="true" />
                      @if (tositeJaTiedot.lomake.pvm; as n) {
                        @if (n().dirty() || n().touched()) {
                          @if ((pvmVar?.ngControl?.dirty || pvmVar?.ngControl?.touched) && pvmVar.ngControl?.errors?.required) {
                            <mat-error>{{ 'kuitit.muokkaa.validation.pvm.required' | translate | async }}</mat-error>
                          }
                          @if ((pvmVar?.ngControl?.dirty || pvmVar?.ngControl?.touched) && pvmVar.ngControl?.errors?.matDatepickerParse) {
                            <mat-error>{{ 'kuitit.muokkaa.validation.pvm.matDatepickerParse' | translate | async }}</mat-error>
                          }
                          @if ((pvmVar?.ngControl?.dirty || pvmVar?.ngControl?.touched) && pvmVar.ngControl?.errors?.matDatepickerMax) {
                            <mat-error>{{ 'kuitit.muokkaa.validation.pvm.matDatepickerMax' | translate | async }}</mat-error>
                          }
                          @if ((pvmVar?.ngControl?.dirty || pvmVar?.ngControl?.touched) && pvmVar.ngControl?.errors?.matDatepickerMin) {
                            <mat-error>{{ 'kuitit.muokkaa.validation.pvm.matDatepickerMin' | translate | async }}</mat-error>
                          }
                        }
                      }
                      <mat-datepicker-toggle matSuffix [for]="monthPicker"></mat-datepicker-toggle>
                      <mat-datepicker #monthPicker></mat-datepicker>
                    </mat-form-field>
                  }
                }
                <br />
                <!-- 'tuote.hinta' | translate | async -->
                @if (showSumma) {
                  <mat-form-field>
                    <mat-label>{{ summaText }}</mat-label>
                    <input decimalNumberField matInput class="alignLeft" [formField]="tositeJaTiedot.lomake.summa" #summaVar="matInput" autocomplete="kirjnpitomekiarki" data-lpignore="true" />
                    @if ((summaVar?.ngControl?.dirty || summaVar?.ngControl?.touched) && summaVar.ngControl?.errors?.required) {
                      <mat-error>{{ 'kuitit.muokkaa.validation.summa.required' | translate | async }}</mat-error>
                    }
                    @if ((summaVar?.ngControl?.dirty || summaVar?.ngControl?.touched) && summaVar.ngControl?.errors?.min) {
                      <mat-error>{{ 'kuitit.muokkaa.validation.summa.min' | translate: { min: summaVar.ngControl.errors.min.min | ldecimal: 2 | async } | async }}</mat-error>
                    }
                    @if ((summaVar?.ngControl?.dirty || summaVar?.ngControl?.touched) && summaVar.ngControl?.errors?.max) {
                      <mat-error>{{ 'kuitit.muokkaa.validation.summa.max' | translate: { max: summaVar.ngControl.errors.max.max | ldecimal: 2 | async } | async }}</mat-error>
                    }
                  </mat-form-field>
                }
                <br />
                @if (showAlv) {
                  @if (alvPortaatObservable | async; as alvPortaat) {
                    <div>
                      <mat-form-field>
                        <mat-label>{{ 'kuitit.muokkaa.alv' | translate | async }}</mat-label>
                        <mat-select [formField]="tositeJaTiedot.lomake.alv">
                          @for (porras of alvPortaat; track porras) {
                            <mat-option [value]="porras"> {{ porras }} % </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                      <br />
                    </div>
                  }
                }
                <mat-form-field>
                  <mat-label>{{ 'kuitit.muokkaa.lisatiedot' | translate | async }}</mat-label>
                  <textarea matInput [formField]="tositeJaTiedot.lomake.lisatiedot" cdkTextareaAutosize cdkAutosizeMinRows="2" cdkAutosizeMaxRows="35" autocomplete="kirjnpitomekiarki"></textarea>
                </mat-form-field>
                <div class="button-container">
                  @if (tositeJaTiedot.naytaTallenna) {
                    <div>
                      @if (virheviestiLatausOnKeskenObservable | async; as viesti) {
                        <div class="error-text" style="padding-bottom: 2em">
                          {{ viesti }}
                        </div>
                      }
                      @if ((latausvirheetObservable | async)?.length > 0) {
                        <div class="error-text" style="padding-bottom: 2em; text-align: left">
                          {{ 'lasku.tiedoston-lahettaminen-epaonnistui-alku' | translate | async }}
                          <ul>
                            @for (virhe of latausvirheetObservable | async; track virhe) {
                              <li>{{ virhe }}</li>
                            }
                          </ul>
                          {{ 'lasku.tiedoston-lahettaminen-epaonnistui-loppu' | translate | async }}
                        </div>
                      }
                      <button class="primarybutton" mat-button (click)="save()">{{ 'yleiset.tallenna' | translate | async }}</button>
                      <br />
                      @if (1 > (latausvirheetObservable | async)?.length && 100 > (donePercentageObservable | async)) {
                        <div style="width: 50%; margin-top: 2em; text-align: center; display: inline-block">
                          <mat-progress-bar mode="determinate" [value]="donePercentageObservable | async"></mat-progress-bar>
                          <div style="padding-top: 3px; font-size: 12px">{{ 'kuitit.muokkaa.ladataan' | translate | async }}</div>
                        </div>
                      }
                    </div>
                  }
                </div>
              </form>
            </div>
            <div class="tosite-sivut">
              <!-- <div *ngIf="(tositeJaTiedot.tiedostotSubject | async)?.length < 1">
                LIIAN VÄHÄN TIEDOSTOJA!
              </div> -->
              @if (tositeJaTiedot.tiedostotSubject | async; as tiedostot) {
                @for (tiedosto of tiedostot; track tiedosto; let i = $index) {
                  <div class="tosite-tiedosto">
                    @if (tiedostot.length > 1) {
                      <h1 style="font-size: 28px; line-height: 34px; text-align: left" class="light-blue-text">{{ 'kuitit.muokkaa.tiedosto' | translate | async }} {{ i + 1 }}</h1>
                    }
                    <!-- <button class="poista-btn mat-elevation-z4" mat-icon-button (click)="poistaTiedosto(tositeJaTiedot, tiedosto)" type="button">
                    <mat-icon class="poista-icon">close</mat-icon>
                  </button> -->
                    @if (tiedosto.kuvat.length > 1) {
                      <div class="image-change-page-buttons-container">
                        @for (kuva of tiedosto.kuvat; track kuva; let a = $index) {
                          <div class="image-change-page-button lemon-mat-elevation-z4" [class.selected-image]="kuva == tiedosto.nakyvaKuva" (click)="vaihdaNakyvaKuva(tiedosto, kuva)">
                            {{ a + 1 }}
                          </div>
                        }
                      </div>
                    }
                    <!-- *ngIf="!(tiedosto?.uploadData?.statusObservable | async)?.error && 100 > (tiedosto?.uploadData?.statusObservable | async)?.donePercentage" -->
                    @if (tiedosto?.uploadData?.statusObservable | async; as status) {
                      @if (!status.error) {
                        <table style="width: 100%" cellPadding="0" cellSpacing="0">
                          <tr>
                            <td width="*">
                              @if (status.donePercentage < 100) {
                                <div style="padding-top: 0px; font-size: 12px; line-height: 14px">{{ 'kuitit.muokkaa.ladataan' | translate | async }}</div>
                              }
                              @if (status.donePercentage > 99.99) {
                                <div style="padding-top: 0px; font-size: 12px; line-height: 14px">{{ 'kuitit.muokkaa.lataus-valmis' | translate | async }}</div>
                              }
                              <mat-progress-bar mode="determinate" [value]="status.donePercentage"></mat-progress-bar>
                            </td>
                            <td style="width: 20px">
                              @if (status.donePercentage > 99.99) {
                                <mat-icon style="height: 18px; width: 18px" class="green-text">done</mat-icon>
                              }
                            </td>
                          </tr>
                        </table>
                      }
                    }
                    <div app-tosite-kuva [url]="tiedosto.nakyvaKuva" class="mat-elevation-z4" style="width: 1080px; max-width: 100%; margin-bottom: 8cqw; position: relative; min-height: 50px"></div>
                  </div>
                }
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>
} @else {
  <div style="text-align: center; padding: 50px 0">
    <mat-spinner style="display: inline-block"></mat-spinner>
    <div style="text-align: center; padding: 20px 0">{{ 'kuitit.muokkaa.kasitellaan' | translate | async }}</div>
  </div>
}
